
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {}
})
export default class ManageModule extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/ab80109404c8fe0a0dda2bd6c60cb510.png";
  pic2 = "/img/b810f8037dde77410301129035295712.png";
  pic3 = "/img/0c0de37f07a918f87d9b85c0feaec440.png";
  pic4 = "/img/65c941535a03af4e2dfb9c9e2b34dd44.png";
  pic5 = "/img/cb6895493c9fb3cc0088081103a84002.png";
  pic6 = "/img/fbf7b626faf6ab21b9e1655fc2571a8b.png";
  pic7 = "/img/c093d5479fe13af9f103c1ad4655a388.png";
}
